module.exports = require("moment/locale/zh-cn");


//////////////////
// WEBPACK FOOTER
// external "moment/locale/zh-cn"
// module id = 18
// module chunks = 0